import { isBankFundingMethod, providerFundingMethod } from '../bank-transfers/types.js';
import { fundingMethodPolicy } from './manifest-policy.js';
import { FUNDING_METHODS, isHostedFundingMethod, } from './policy.js';
/** Visibility is configuration-owned; only live discovery authorizes selection. */
export function configuredFundingMethods(manifest, directPurchase = false) {
    const provider = directPurchase
        ? manifest.direct_token_purchase.providers.moonpay
        : manifest.onramp.providers.moonpay;
    if (!provider.enabled)
        return [];
    return FUNDING_METHODS.filter((method) => {
        if (directPurchase && method !== 'card' && method !== 'apple_pay' && method !== 'google_pay')
            return false;
        const policy = directPurchase && (method === 'card' || method === 'apple_pay' || method === 'google_pay')
            ? manifest.direct_token_purchase.providers.moonpay.methods[method]
            : fundingMethodPolicy(manifest, method);
        return policy.enabled && policy.surfaces.length > 0;
    });
}
export function unavailableFundingMethods(options) {
    return configuredFundingMethods(options.manifest, options.directPurchase)
        .filter((method) => !isBankFundingMethod(method) && !options.methods.includes(method))
        .map((method) => {
        const config = options.configs.find((entry) => entry.type === providerFundingMethod(method));
        let reason = 'provider_unavailable';
        if (!fundingMethodPolicy(options.manifest, method).surfaces.includes(options.surface))
            reason = 'device_unavailable';
        else if ((method === 'apple_pay' || method === 'google_pay') &&
            !options.deviceMethods.includes(method))
            reason = 'device_unavailable';
        else if (config?.availability.active &&
            config.capabilities.supportedTransactionTypes.includes('buy')) {
            if (config.capabilities.requiresWidget !== isHostedFundingMethod(method))
                reason = 'execution_unavailable';
            else if (!config.capabilities.supportedCurrencies.includes(options.currency))
                reason = 'currency_unavailable';
        }
        return { method, reason };
    });
}
